import { useAppContext } from '../context/appContext';
import { Navigate } from 'react-router-dom';
import Loading from './loading';
const ProtectedRoute = ({ children }) => {
  const { user, userLoading } = useAppContext();

  if (userLoading) return <Loading />;

  if (!user) {
    return <Navigate to='/e-commerce/register' />;
  }
  return children;
};

export default ProtectedRoute;
